import { ResourceOptions } from 'react-admin';
import { FaList } from 'react-icons/fa';
import { Resources } from '../../resource';

import './dataProvider';

export { default as list } from './List';

export const name = Resources.coinSymbols;
export const icon = FaList;
export const options: ResourceOptions = {
  label: 'resource.coinSymbols',
};
